import type { ReactElement } from 'react';
import { Link, useLocation } from 'react-router-dom';

function linkClass(active: boolean): string {
  return active ? 'app-main-nav-link app-main-nav-link--active' : 'app-main-nav-link';
}

export function AdminNav(): ReactElement {
  const { pathname } = useLocation();
  return (
    <nav className="app-main-nav" aria-label="Admin">
      <Link to="/" className={linkClass(false)}>
        Modules
      </Link>
      <Link to="/admin" className={linkClass(pathname.startsWith('/admin'))}>
        Admin
      </Link>
    </nav>
  );
}
